import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IUsageRepository').IUsageRepository} */
export class UsageRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getCharacterStats(start_unix, end_unix, options = {}) {
    if (!start_unix || !end_unix) {
      throw new Error('start_unix and end_unix are required parameters');
    }

    return this.client.get(ENDPOINTS.USAGE.CHARACTER_STATS, {
      params: {
        start_unix,
        end_unix,
        ...options,
      },
    });
  }
}
